import { render } from "./CardWallet.vue?vue&type=template&id=6004cf25&scoped=true"
import script from "./CardWallet.vue?vue&type=script&lang=js"
export * from "./CardWallet.vue?vue&type=script&lang=js"

import "./CardWallet.vue?vue&type=style&index=0&id=6004cf25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6004cf25"],['__file',"src/components/Cards/CardWallet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6004cf25"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6004cf25', __exports__)) {
    api.reload('6004cf25', __exports__)
  }
  
  module.hot.accept("./CardWallet.vue?vue&type=template&id=6004cf25&scoped=true", () => {
    api.rerender('6004cf25', render)
  })

}


export default __exports__